import { createFileRoute } from "@tanstack/react-router";
import { PublicPlayerDetail } from "@/features/players";
import { loadPublicPlayer } from "@/features/game-resources/records";
import {
  resourceHead,
  ResultsFrame,
  resourceSearchSchema,
} from "@/features/game-resources/navigation";

export const Route = createFileRoute("/_site/players/$playerId")({
  validateSearch: (search) => resourceSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ params, deps, abortController }) =>
    loadPublicPlayer({
      data: { resourceId: params.playerId, search: deps.search },
      signal: abortController.signal,
    }),
  head: () => resourceHead("Player"),
  component: Page,
});

function Page() {
  const data = Route.useLoaderData();
  const { playerId } = Route.useParams();
  return (
    <ResultsFrame viewer={data.viewer}>
      <PublicPlayerDetail
        key={playerId}
        playerId={playerId}
        initialAchievements={data.achievements}
        initialDataUpdatedAt={data.generatedAt}
      />
    </ResultsFrame>
  );
}
